module.exports = __webpack_public_path__ + "static/Averta-Bold-e5d5c2523c230ac00a0b972ec7ca98b3.woff";